import React from "react";

const SelectedDeviceInfo = (props) => {
  const {selectedDev, isLoading} = props
  //console.log(selectedDev)
  if (selectedDev?.requestData.length === 0) return <></>
  //console.log(selectedDev.requestData.info?.id)
  return (
    <div className="container mt-5">
    <div className="card">
        <div className="card-header">
            <h4>{`Selected Device Info${isLoading?'...':''}`}</h4>
        </div>
        <div className="card-body">
            <p className="card-text">
                <strong>ID:</strong> {selectedDev.requestData.info?.id}
                <span className={'ml-2 ' + `${selectedDev.requestData.isOnline ? 'text-primary': 'text-danger'}`}>
                    {`${selectedDev.requestData.isOnline ? 'onLine': 'offLine'}`}
                </span>
            </p>
            <p className="card-text">
                <strong>Type:</strong> {selectedDev.requestData.info?.type}
            </p>
            <p className="card-text">
                <strong>Device Name:</strong> {selectedDev.requestData.info?.name}
            </p>

{/*             <p className="card-text">
                <strong>Description:</strong> {selectedDev.requestData.info?.description}
            </p> */}
            <p className="card-text">
                <strong>Tags:</strong> {selectedDev.requestData.info?.tags}
            </p>
        </div>
    </div>
</div>
  )
}

export default SelectedDeviceInfo;